export const SANDBOX_SESSION_HEADER = "x-sandbox-session-id"

export const SANDBOX_CHAT_SESSION_TTL_SECONDS = 60 * 60 * 4

export const SANDBOX_POOL_ROLE_NAME = "app_rw"

export const SANDBOX_MAX_SESSIONS_PER_ORG = 3

export const SANDBOX_ATTACHMENT_SPILL_BYTES = 256 * 1024

export const SANDBOX_RERUN_COUNT_DEFAULT = 5
export const SANDBOX_RERUN_COUNT_CAP = 20
export const SANDBOX_RERUN_CONCURRENCY = 5
export const SANDBOX_RERUN_ALL_RUNS_FAILED_CODE =
    "SANDBOX_RERUN_ALL_RUNS_FAILED"
export const SANDBOX_RERUN_COUNT_EXCEEDS_CAP_CODE =
    "SANDBOX_RERUN_COUNT_EXCEEDS_CAP"
export const SANDBOX_RERUN_DRIVE_ALREADY_ACTIVE_CODE =
    "SANDBOX_RERUN_DRIVE_ALREADY_ACTIVE"
export const SANDBOX_RERUN_DRIVE_NOT_FOUND_CODE =
    "SANDBOX_RERUN_DRIVE_NOT_FOUND"
export const SANDBOX_SELF_CHECK_SESSION_TTL_SECONDS = 60 * 10

export const SANDBOX_SESSION_POLL_INTERVAL_MS = 30_000

export const SANDBOX_SESSION_EXPIRING_SOON_MS = 10 * 60 * 1000

export const REPLAY_SESSION_TASK_SETTLE_DELAY_MS = 15_000
